import createCrudVuexModule from "@/store/crud";

export const sourceAndType = createCrudVuexModule({
  namespaced: true,
  path: "/library/source-and-type",
  moduleName: `source-and-type`,
});

export const workspaceSourceAndType = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/source-and-type",
});

export const managementSourceAndType = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/source-and-type",
});
